import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Container,
} from "@mui/material";
import imgUrl from "../assets/images/imgUrl";

const earnCards = [
  {
    text: (
      <>
        <b> Earn a 21% <br /> incentive on <br /> contributions <br /> made through <br /> unique QR code <br /> referral link. </b> 
      </> 
    ),
    color: 'gradient-blue',
  },
  {
    text: (
      <>
        <b> Present <i> I Am <br />Peacekeeper </i> <br /> Gifts and receive <br /> 7% of proceeds.</b>
      </>
    ),
    color: 'gradient-yellow',
  },
  {
    text: (
      <>
        <b> Promote <br /> pledges,campaigns<br /> and referrals for the <i> I Am Peacekeeper Movement. </i> </b> 
      </>
    ),
    color: "gradient-blue",
  },
  {
    text: (
      <>
        <b> Use your dashboard <br /> to track <br /> referrals, <br /> earnings and impact. </b> 
      </>
    ),
    color: "gradient-yellow",
  },
  {
    text: (
      <>
        <b> Earn <br />VIP invites.</b>
      </>
    ),
    color: "gradient-blue",
  },
  {
    text: (
      <>
        <b> Register as a <br /> referrer <br /> for the <i> I Am Peacekeeper<br /> Movement.</i></b>
      </>
    ),
    color: "gradient-yellow",
  },
];

const Rewards = () => {
  return (
    <>
      {/* Home 7Qualities section */}
      <Box
        className="rewardsBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          px: 2,
        }}
        mb={5}
      >
        {/* Mini Header (Top-Left) */}
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Rewards Main Container Section  */}
      <Box className="earn-container">

        {/* reward quote section */}
        <div className="earnQuoteBgSection" style={{ flexDirection: 'column', gap: '10px' }}>
          {/* Changed to H1 as per requirement */}
          <h1>Income through Values</h1>
          {/* Changed to H2 and removed '-' as per requirement */}
          <h2>Serving others while supporting yourself.</h2>
        </div>

        {/* Rewards Heading section  */}
        <Box className="">
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item xs={12}>
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg" alt="Peace Icon" />
              {/* Changed variant to h2 as per requirement */}
              <Typography variant="h2" className="founder-title mainHeading green-title">
                Earn Peacefully
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* Earn Cards Grid */}
        <Box mt={3}>
          <Container className="containerDiv">
            <Grid container spacing={3} justifyContent="center">
              {earnCards.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card className={`earn-card ${item.color}`}>
                    <CardContent>
                      {/* Using earn-text class which maps to Primary Paragraph Font (--default-font) in CSS */}
                      <Typography className="earn-text">
                        {item.text}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
            
            {/* Highlight Box Section */}
            <Grid container spacing={2} className="earn-highlight-box" mt={4}>
                <Grid item xs={12}>
                  {/* Using highlightText class which maps to Primary Paragraph Font in CSS */}
                  <Typography className="highlightText">
                    <b>
                    <i> I Am Peacekeeper </i>Partner (USD 12,000) contribution for the{" "}
                    <i>Billionaires for Peace Conclave </i> </b> .
                    <br />
                    Earn 21% on every successful contribution.
                  </Typography>
                </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default Rewards;